import React from 'react';

export interface WidgetProps {
  /** Optional leading icon node (e.g. <WidgetIcon …/>). */
  icon?: React.ReactNode;
  /** Header title. Omit to render a header-less widget. */
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right-aligned header content (e.g. a "View all" link). */
  headerRight?: React.ReactNode;
  /** Tab bar slot — render `<button className="gt-tab …">` children into it. */
  tabs?: React.ReactNode;
  /** Footer slot (e.g. a Show More / Load More / View all button). */
  footer?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  bodyRef?: React.Ref<HTMLDivElement>;
  children: React.ReactNode;
}

/**
 * Shared sidebar/overview widget shell. One header vocabulary for every gov-trades
 * surface: optional icon + left-aligned title + optional subtitle, an optional tab
 * bar, a scrollable body, and an optional footer.
 */
export const Widget = ({
  icon,
  title,
  subtitle,
  headerRight,
  tabs,
  footer,
  className,
  bodyClassName,
  bodyRef,
  children,
}: WidgetProps) => (
  <div className={['gt-widget', className ?? ''].filter(Boolean).join(' ')}>
    {title || icon || subtitle ? (
      <div className="gt-widget__head">
        {icon ? <span className="gt-widget__icon">{icon}</span> : null}
        <div className="gt-widget__heading">
          {title ? <span className="gt-widget__title">{title}</span> : null}
          {subtitle ? <span className="gt-widget__sub">{subtitle}</span> : null}
        </div>
        {headerRight ? <span className="gt-widget__head-right">{headerRight}</span> : null}
      </div>
    ) : null}
    {tabs ? <div className="gt-widget__tabs">{tabs}</div> : null}
    <div className={['gt-widget__body', bodyClassName ?? ''].filter(Boolean).join(' ')} ref={bodyRef}>
      {children}
    </div>
    {footer ? <div className="gt-widget__footer">{footer}</div> : null}
  </div>
);
